import { Img, Text } from "components";
import { useTranslation } from "react-i18next";
import * as CUSTOM from "../../utils/helper/custom";

const RecipientFormThankYouPage = ({ orderData }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="flex flex-col items-center justify-start w-full font-['Inter']">

        {/* ── Celebration image (party hats + balloons) ── */}
        {/* Replace src with actual local image when available */}
        <div className="mb-6 mt-2">
          <Img
            className="h-[140px] w-auto object-contain"
            src="/images/celebrate2.png"
            alt="celebration"
          />
        </div>

        {/* ── Thank You heading ── */}
        <Text
          className="text-[32px] font-bold sm:text-2xl text-[#771237] font-[Unbounded] text-center mb-3"
        >
          {t("thankYou")}!
        </Text>

        {/* ── Subtitle ── */}
        <Text
          className="leading-[26px] text-base text-center text-gray-600 font-Inter max-w-[420px] mb-8 px-4"
          style={{
                  color: "var(--Main-Color-Primary, #8D4660)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "500",
                }}
        >
          {t("yourDetailsHasBeenSuccessfullySentToTheSenderDot")}{" "}
          {t("youWillReceiveYourGiftOnceTheSenderConfirmsThe")}{" "}
          {t("detailsOfTheOrderDot")}
        </Text>

        {/* ── Details card ── */}
        <div
          className="w-full max-w-[560px] bg-white-A700 rounded-2xl px-6 py-5 flex flex-col gap-4 mx-auto"
          style={{ boxShadow: "0px 2px 20px 0px rgba(0,0,0,0.06)" }}
        >
          {/* Address row */}
          <div className="flex flex-row items-start gap-3">
            {/* Location pin icon */}
            <svg className="h-5 w-5 mt-0.5 flex-shrink-0 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8"
                d="M12 21c-4-4.5-7-8.2-7-11a7 7 0 1114 0c0 2.8-3 6.5-7 11z" />
              <circle cx="12" cy="10" r="2.5" strokeWidth="1.8" />
            </svg>
            <Text className="text-sm text-gray-700 font-Inter leading-relaxed">
              {orderData?.address_details?.address ||
                CUSTOM.buildFullAddress(orderData?.addressData) ||
                "—"}
            </Text>
          </div>

          {/* Divider */}
          <div className="h-px bg-gray-100 w-full" />

          {/* Name + phone row */}
          <div className="flex flex-row items-start gap-3">
            
            <svg className="h-5 w-5 mt-0.5 flex-shrink-0 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8"
                d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
              <circle cx="12" cy="7" r="4" strokeWidth="1.8" />
            </svg>
            <div className="flex flex-col gap-0.5">
              <Text className="text-sm text-black-900 font-Inter">
                {orderData?.orderDetails?.giftDetails?.recipient_name || "—"}
              </Text>
              <Text className="text-xs text-gray-500 font-Inter">
                {orderData?.orderDetails?.giftDetails?.mobile_no
                  ? `${orderData.orderDetails.giftDetails.country_code || ""} ${orderData.orderDetails.giftDetails.mobile_no}`
                  : "—"}
                  &nbsp;
                  {"|"}
                {orderData?.orderDetails?.giftDetails?.occasion_name
                  ? ` ${orderData.orderDetails.giftDetails.occasion_name}`
                  : ""}
              </Text>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gray-100 w-full" />

          {/* Date + time slot row */}
          <div className="flex flex-row items-center gap-3">
            {/* Calendar icon */}
            <svg className="h-5 w-5 flex-shrink-0 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="2" strokeWidth="1.8" />
              <path strokeLinecap="round" strokeWidth="1.8" d="M16 2v4M8 2v4M3 10h18" />
            </svg>
            <Text className="text-sm text-gray-700 font-Inter">
              {orderData?.delivery_date
                ? CUSTOM.changeDateFormat(orderData.delivery_date, "dd/MM/yyyy")
                : "—"}
              {orderData?.timeLabel ? ` ${orderData.timeLabel}` : ""}
            </Text>
          </div>
        </div>

        {/* 
          Old design (commented out, not removed):
          <div className="bg-white-A700 flex flex-col gap-[30px] items-center justify-start p-[52px] md:px-10 sm:px-5 shadow-bs2 w-[730px] sm:w-[90%] md:w-full mx-auto mb-[145px] sm:relative sm:z-[5]">
            <Img className="h-[22px] absolute left-0 right-0 mt-[-65px] mx-auto" src="/images/img_signal.svg" alt="signal" />
            <div className="bg-red-100 flex flex-col h-20 items-center justify-center p-2.5 rounded-[50%] w-20">
              <Img className="h-[60px] w-[60px]" src="/images/img_checkmark_pink_800.svg" alt="checkmark" />
            </div>
            <Text className="text-2xl md:text-[22px] text-black-900 sm:text-xl" size="txtnunitoSemiBold24">
              {t("thankYou")}
            </Text>
            <Text className="leading-[24.00px] text-base text-center text-gray-700" size="txtnunitoRegular16Gray700">
              <>
                {t("yourDetailsHasBeenSuccessfullySentToTheSenderDot")}
                <br />
                {t("youWillReceiveYourGiftOnceTheSenderConfirmsThe")}
                <br />
                {t("detailsOfTheOrderDot")}
              </>
            </Text>
          </div>
        */}

      </div>
    </>
  );
};

export default RecipientFormThankYouPage;